import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getUserV2Options } from 'client/@tanstack/react-query.gen';
import { canAccessUsersUserIdRoutes } from 'helpers/query';
import {
  isUsersRouteExecutiveSelf,
  viewedUserForExecutiveSelf,
} from 'helpers/viewedUser';

/**
 * /users/$userId/* lives outside _internal so URLs match the future external user area.
 * Admins may view any user; executives may view only their own id (see `canAccessUsersUserIdRoutes`).
 */
export const Route = createFileRoute('/_private/_route/users/$userId')({
  validateSearch: z.object({
    person_uuid: z.string().optional().catch(undefined),
  }),
  beforeLoad: async ({ context, params }) => {
    // context.user is the logged-in person from /_private — do not shadow it.
    if (!canAccessUsersUserIdRoutes(context.user, params.userId)) {
      throw redirect({ replace: true, to: '/' });
    }

    if (isUsersRouteExecutiveSelf(context.user, params.userId)) {
      return { viewedUser: viewedUserForExecutiveSelf(context.user) };
    }

    const { queryClient } = context;
    const pUser = queryClient.ensureQueryData(
      getUserV2Options({
        path: {
          user_uuid: params.userId,
        },
      }),
    );
    const viewedUser = await pUser;
    return { viewedUser };
  },
  component: Outlet,
});
